var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function twoUpVideo(el) {
	this.el = el;
	this.$el = $(el);
}

module.exports = twoUpVideo;